import {
  ACTIVITY_CREATE_FAILED,
  ACTIVITY_CREATE_REQ,
  ACTIVITY_CREATE_RESET,
  ACTIVITY_CREATE_SUCCESS,
  ACTIVITY_DETAILS_FAILED,
  ACTIVITY_DETAILS_REQ,
  ACTIVITY_DETAILS_SUCCESS,
  ACTIVITY_DETAILS_UPDATE_FAILED,
  ACTIVITY_DETAILS_UPDATE_REQ,
  ACTIVITY_DETAILS_UPDATE_RESET,
  ACTIVITY_DETAILS_UPDATE_SUCCESS,
} from "../constants/activityConstant";

export const activityDetailsReducer = (state = {}, { type, payload,eventActivity }) => {
  switch (type) {
    case ACTIVITY_DETAILS_REQ: {
      return { loading: true };
    }

    case ACTIVITY_DETAILS_SUCCESS: {
      return { loading: false, activityDet: payload,eventActivity };
    }
    case ACTIVITY_DETAILS_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};

export const activityCreateDetailsReducer = (
  state = {},
  { type, payload, contactId }
) => {
  switch (type) {
    case ACTIVITY_CREATE_REQ: {
      return { loading: true };
    }

    case ACTIVITY_CREATE_SUCCESS: {
      return { loading: false, success: payload, contactId };
    }
    case ACTIVITY_CREATE_FAILED: {
      return { loading: false, error: payload };
    }

    case ACTIVITY_CREATE_RESET: {
      return { loading: false };
    }
    default:
      return state;
  }
};

export const activityUpdateDetailsReducer = (
  state = {},
  { type, payload, contactId }
) => {
  switch (type) {
    case ACTIVITY_DETAILS_UPDATE_REQ: {
      return { loading: true };
    }

    case ACTIVITY_DETAILS_UPDATE_SUCCESS: {
      return { loading: false, success: payload, contactId };
    }

    case ACTIVITY_DETAILS_UPDATE_FAILED: {
      return { loading: false, error: payload };
    }

    case ACTIVITY_DETAILS_UPDATE_RESET: {
      return {};
    }
    default:
      return state;
  }
};
